import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";

export function useDocumentExpiration() {
	const { t } = useTranslation("document-expiration");
	const rootStore = useRootAppStore();

	if (rootStore == null) {
		throw Error("should be used in components");
	}

	const offlineUser = rootStore.userAuthStore.shopUser;

	const onlineUser = rootStore.userAuthStore.onlineUser;

	if (
		!offlineUser?.userDocumentDateNotSet &&
		!offlineUser?.userDocumentDateExpiresSoon &&
		!offlineUser?.userDocumentDateExpired &&
		!onlineUser?.userDocumentDateNotSet &&
		!onlineUser?.userDocumentDateExpiresSoon &&
		!onlineUser?.userDocumentDateExpired
	) {
		return null;
	}

	let message;

	if (
		offlineUser?.userDocumentDateNotSet ||
		onlineUser?.userDocumentDateNotSet
	) {
		message = t("document-expiration:DATE_NOT_SET");
	} else if (
		offlineUser?.userDocumentDateExpiresSoon ||
		onlineUser?.userDocumentDateExpiresSoon
	) {
		message = t("document-expiration:DATE_EXPIRE_SOON");
	} else {
		message = t("document-expiration:BETTING_EXPIRED");
	}

	return {
		message,
	};
}
